document.addEventListener('DOMContentLoaded', checkOrientationAndWidth);
window.addEventListener('resize', checkOrientationAndWidth);

function checkOrientationAndWidth() {
    const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const isLandscape = window.matchMedia("(orientation: landscape)").matches;

    if (w > 576 && isLandscape) {
        document.getElementById("scmSHv").style.display = "block";
        document.getElementsByTagName("footer")[0].style.marginBottom = "0px";
    } else if (document.getElementsByClassName("content__mainlinks").length > 0) {
        // hiding Green Chat Element to not appear above main link icons
        document.getElementById("scmSHv").style.display = "none";
        document.getElementsByTagName("footer")[0].style.marginBottom = "100px";
    }
}
